import _ from 'lodash';

export function getUpdateCollection(collection, id, fields) {
  return _.map(collection, (item) => (item.id === id ? { ...item, ...fields } : item));
}

export function greet() { return 'Hello!'; }
